import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import { useCallback, useMemo } from 'react';
import {
  getSelectedMemberId,
  removeMemberFromLedgerAccounts,
} from 'reducers/membersReducer';
import columnDefs from '../columnDefs';
import RemoveLedgerRenderer from '../cellRenderers/RemoveLedgerRenderer';

export const REMOVE_LEDGER_COL_ID = 'removeLedgerColId'
const useColumnDefs = () => {
  const dispatch = useAppDispatch();
  const selectedMemberId = useAppSelector(getSelectedMemberId);

  const removeLedgerAccounts = useCallback(
    (account: string) => {
      dispatch(
        removeMemberFromLedgerAccounts({
          memberId: selectedMemberId,
          accountIds: [account],
        }),
      );
    },
    [dispatch, selectedMemberId],
  );

  const colDefs = useMemo(() => {
    return [
      ...columnDefs,
      {
        headerName: '',
        colId: REMOVE_LEDGER_COL_ID,
        width: 150,
        cellRenderer: RemoveLedgerRenderer,
        cellRendererParams: {
          remove: removeLedgerAccounts,
        },
      },
    ];
  }, [removeLedgerAccounts]);

  return colDefs;
};

export default useColumnDefs;
